import { FC } from 'react';

import { NewOfferForm } from './New/NewOfferForm';

const New: FC = () => {
    return (
        <div className="pt-6 pb-6">
            <NewOfferForm />
        </div>
    );
};

export default New;
